import Link from 'next/link';
import { useTranslate } from '@tolgee/react';
import { SearchScope } from '@amf/shared/components/search/hooks/useAdvancedSearch';
import { SearchResultWithPlayerFragment } from '@amf/shared/types/graphql';
import { getInitials } from '@amf/shared/utils/string';

type Props = {
  item: SearchResultWithPlayerFragment;
  prefixes: { player: string };
};

function PlayerResult({ item, prefixes }: Props) {
  const { t } = useTranslate();
  return (
    <Link href={`${prefixes.player}/${item.id}`} passHref>
      <a className='AdvancedSearch__resultItem'>
        {item.photoUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={item.photoUrl} alt={item.name} className='AdvancedSearch__resultItemImage' />
        ) : (
          <div className='AdvancedSearch__resultItemImage'>
            {getInitials(item.givenName, item.familyName)}
          </div>
        )}
        <div className='AdvancedSearch__resultItemContent'>
          <div className='AdvancedSearch__resultItemType'>
            {t(`search.scope.${SearchScope.PLAYERS}.one`)}
          </div>
          <h3 className='AdvancedSearch__resultItemTitle'>{item.name}</h3>
          <p className='AdvancedSearch__resultItemDescription'>
            {item.currentTeamNames.map(name => (
              <span key={name} className='AdvancedSearch__resultItemTeam'>
                {name}
              </span>
            ))}
          </p>
        </div>
      </a>
    </Link>
  );
}

export default PlayerResult;
